import { render, staticRenderFns } from "./CharactersSlider.vue?vue&type=template&id=200c0175&"
import script from "./CharactersSlider.vue?vue&type=script&lang=js&"
export * from "./CharactersSlider.vue?vue&type=script&lang=js&"
import style0 from "./CharactersSlider.vue?vue&type=style&index=0&id=200c0175&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports